import { apiUrls } from "../../config/apiUrls";
import { IApiServiceResponse } from "../../types/api";
import basicRequest from "../basicRequest";

export type BusinessProfilePostData = {
    name: string;
    city: string;
    line: string;
    zipcode: string;
    vatnr: string | null;
    taxcode: string | null;
}

export const notificationsService = {
    getNotificationsToRead: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getNotificationsToRead);
    },
    getNotificationsBulk: async (page: number, count: number): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.get(apiUrls.getNotificationsBulk, {
            pageNumber: page,
            count: count
        });
    },
    readNotification: async (id: string): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.readNotification, {
            id: id
        });
    },
    readAllNotifications: async (): Promise<IApiServiceResponse> => {
        const request = new basicRequest();
        return await request.post(apiUrls.readAllNotifications, {});
    },
}